import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getAppVersion } from '@/tool';

Vue.use(VueI18n)

import en from './en'
import zh from './zh'

export default new VueI18n({
  locale: getAppVersion() === "ZH" ? 'zh' : 'en',
  messages: {
    en,
    zh
  }
})



// WEBPACK FOOTER //
// ./src/lang/index.js